export default "__VITE_ASSET__CF8hmma1__"